import * as qs from 'qs';
import {API} from '../API';
import {ItemService} from './ItemService';

export class PackingListService {

  constructor() {
    this.item = new ItemService();
  }

  async getTableLists(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getLists(query, page, length);
  }

  async getLists(query, page, length) {
    return (await API.getConnection())
      .get('packing-lists', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async saveList(data) {
    let method = 'post';
    let url = 'packing-lists';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async getList(id, archive = false) {
    return (await API.getConnection())
      .get(`packing-lists/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async downloadList(list) {
    return (await API.getConnection())
      .get(`packing-lists/${list.id}/download`, {
        responseType: 'blob',
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['x-filename']);
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => API.handleError(error));
  }

  async lockList(list) {
    return (await API.getConnection())
      .put(`packing-lists/${list.id}/lock`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async unlockList(list) {
    return (await API.getConnection())
      .put(`packing-lists/${list.id}/unlock`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteList(list) {
    return (await API.getConnection())
      .delete(`packing-lists/${list.id}`)
      .then(() => null)
      .catch(error => API.handleError(error));
  }

  async restoreList(list) {
    return (await API.getConnection())
      .put(`packing-lists/${list.id}/restore`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
